<template>
  <div class="integral">
    <div class="title">积分兑换</div>
    <div class="top flex">
      <div class="logo-box"  @click="goJump">
        <img class="logo" src="../../../assets/images/hisTrack/defaultPic.png" alt srcset />
      </div>
      <div class="logo-right">
        <div>请登录</div>
        <div>积分将于12月31日到期</div>
      </div>
    </div>
    <div class="point-list flex">
      <div class="point-item" v-for="item in cardList" :key="item.id">
        <div class="header">
          <img :src="carurl" alt srcset />
          <div class="header-name">{{ item.goodsName }}</div>
        </div>
        <div class="bottom">
          <div class="name">{{ item.goodsName }}</div>
          <div class="fraction flex">
            <div class="number">{{ item.integral }}分</div>
            <div class="btn" @click="goJump">立即兑换</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createClickStatistics } from '../../../api/searchCar'
export default {
  props: {},
  data() {
    return {
      carurl: 'http://ftpfile.yunlsp.com/storage/vehicle/truckmp/free/car.png',
      cardList: [
        {
          goodsName: '1票',
          id: 1,
          integral: 100
        },
        {
          goodsName: '10票',
          id: 2,
          integral: 990
        },
        {
          goodsName: '50票',
          id: 3,
          integral: 4950
        },
        {
          goodsName: '100票',
          id: 4,
          integral: 9900
        }
      ]
    };
  },
  computed: {
    platform () {
      const u = navigator.userAgent
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        return 'Android'
      } else {
        return 'ios'
      }
    }
  },
  components: {},
  async created() {
    await createClickStatistics({type: 76, value: 1})
  },
  mounted() {},
  watch: {},
  methods: {
    /**
     *
     *
     * 跳转下载
    */
    goJump () {
      window.location.href = this.platform === 'Android' ? 'vehicleapp://vehicle:8080/loadtoolhome' : 'wx91994a41ed7b033a://'
      setTimeout(() => {
        window.location.href = process.env.VUE_APP_URL + 'recall-download'
      }, 1000)
    }
  }
};
</script>

<style scoped lang="scss">
.integral {
  background-color: #f2f2f2;
  min-height: 100vh;
  .title {
    background-color: #5572fd;
    text-align: center;
    color: #ffffff;
    font-size: 36px;
    padding-top: 20px;
    font-weight: bold;
  }
  .top {
    height: 230px;
    background-color: #5572fd;
    .logo-box {
      margin-top: 80px;
      margin-left: 20px;
      .logo {
        width: 120px;
      }
    }
    .logo-right {
      padding-top: 90px;
      padding-left: 20px;
      font-size: 26px;
      color: #ffffff;
      :first-child {
        font-weight: bold;
        padding-bottom: 20px;
        font-size: 30px;
      }
    }
  }
  .point-list {
    margin: 20px;
    flex-wrap: wrap;
    overflow-y: scroll;
    .point-item {
      margin: 0 10px 20px 10px;
      width: calc(50% - 20px);
      .header {
        text-align: center;
        width: 100%;
        padding-bottom: 26px;
        img {
          width: 260px;
          height: 100px;
          padding-top: 80px;
          padding-bottom: 30px;
        }
        .header-name {
          color: #ffffff;
          font-size: 40px;
        }
      }
      .bottom {
        padding: 20px;
        padding-bottom: 10px;
        background-color: #ffffff;
        .name {
          font-size: 24px;
          color: #656565;
        }
        .fraction {
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
          .number {
            color: #ff6012;
            font-size: 24px;
          }
          .btn {
            color: white;
            font-size: 24px;
            background-color: #5572fd;
            border-radius: 4px;
            border: none;
            line-height: 40px;
            padding: 10px;
          }
        }
      }
    }
  }
  .point-list .point-item:nth-child(1) .header {
    background-color: #fdac39;
  }
  .point-list .point-item:nth-child(2) .header {
    background-color: #fd7939;
  }
  .point-list .point-item:nth-child(3) .header {
    background-color: #fc3975;
  }
  .point-list .point-item:nth-child(4) .header {
    background-color: #fc4b39;
  }
}
</style>
